import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useFormServiceGroup, useI18n } from "../../../../contexts";
import { RollbackOutlined } from "@ant-design/icons";
const FormServiceGroupFieldDescription = ()=>{
    const { __ } = useI18n();
    const { defaultTemplateValues: { description: defaultDescription } } = useFormServiceGroup();
    return /*#__PURE__*/ _jsx(Form.Item, {
        label: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                __("Description"),
                !!defaultDescription && /*#__PURE__*/ _jsx(Form.Item, {
                    shouldUpdate: (prevValues, nextValues)=>prevValues.name !== nextValues.name,
                    noStyle: true,
                    children: (param)=>{
                        let { getFieldValue, setFieldsValue } = param;
                        return getFieldValue("description") !== defaultDescription && /*#__PURE__*/ _jsx("a", {
                            style: {
                                marginLeft: 10
                            },
                            onClick: ()=>setFieldsValue({
                                    description: defaultDescription
                                }),
                            children: /*#__PURE__*/ _jsx(RollbackOutlined, {})
                        });
                    }
                })
            ]
        }),
        name: "description",
        required: true,
        style: {
            marginBottom: 12
        },
        rules: [
            {
                required: true,
                message: __("Please enter a description!")
            }
        ],
        children: /*#__PURE__*/ _jsx(Input.TextArea, {
            autoSize: true,
            onKeyDown: (e)=>/**
                     * `rc-tabs` defines an `onKeyDown` event which causes issues with enter and spaces and avoids
                     * input fields in the tab to get filled correctly.
                     *
                     * @see https://git.io/JUZZO
                     */ e.stopPropagation()
        })
    });
};
export { FormServiceGroupFieldDescription };
